<template>
    <div v-if="show" class="user-panel">
        <table v-if="isExpireTrialContract()" width=100% class="alertfield">
            <tr v-if="isBillingPaper()" class="alertrecord" v-t="{ path: 'message.info_trial_expire_notice_for_customer', args: { expireDate: getExpireDateTime() } }"></tr>
            <tr v-else class="alertrecord" v-t="{ path: 'message.info_trial_expire_notice_for_web', args: { expireDate: getExpireDateTime() } }"></tr>
        </table>
        <table v-else-if="isExpirePurchasedContract()" width=100% class="alertfield">
            <tr v-if="isBillingPaper()" class="alertrecord" v-t="{ path: 'message.info_contract_expire_notice_for_customer', args: { expireDate: getExpireDateTime() } }"></tr>
            <tr v-else class="alertrecord" v-t="{ path: 'message.info_contract_expire_notice_for_web', args: { expireDate: getExpireDateTime() } }"></tr>
        </table>
        <table v-else-if="appData.loginIdNotConfirmed" width=100% class="alertfield">
            <tr class="alertrecord"  v-t="{ path: 'message.info_cannot_confirm_user_attribute', args: { loginId: appData.loginId, userId:appData.loginId.split('@')[0]} }">
            </tr>
        </table>
        <table height=100% width=100% cellpadding=0 cellspacing=0 style="table-layout: fixed">
            <colgroup v-if="isTableViewEnable">
                <col style="width:30%">
                <col style="width:70%">
            </colgroup>
            <colgroup v-else>
                <col style="width:50%">
                <col style="width:50%">
            </colgroup>
            <tr height="56px">
                <td :colspan=2>
                    <div class="command-area">
                        <div class="command-area-left">
                            <span v-if="appData.isRadioIntegrated">
                                <el-switch
                                    v-model="isTableViewEnable"
                                    size="large"
                                    active-text="表形式"
                                    @change="handleViewModeChange"
                                />
                            </span>
                            <template v-if="showCreateGroupCommand">
                                <span v-if="disableCreateGroup" style="margin-left: 40px">
                                    <el-tooltip effect="light" placement="top-start" >
                                        <div v-if= "appData.csvProcessing" slot="content" style="text-align:left" v-t="'message.error_import_processing'"></div>
                                        <div v-else slot="content" style="text-align:left" v-t="'message.hint_create_layer'"></div>
                                        <el-button class="disable-command-button" style="width:140px" v-t="'message.action_create_layer'"></el-button>
                                    </el-tooltip>
                                </span>
                                <span v-else style="margin-left: 40px">
                                    <el-button class="enable-command-button" style="width:140px" v-on:click="addGroupCommand()" v-t="'message.action_create_layer'"></el-button>
                                </span>
                            </template>
                            <template v-if="showCreateUserCommand">
                                <span v-if="disableCreateUser">
                                    <el-tooltip effect="light" placement="top-start" >
                                        <div v-if="appData.csvProcessing" slot="content" style="text-align:left" v-t="'message.error_import_processing'"></div>
                                        <div v-else slot="content" style="text-align:left" v-t="'message.hint_create_user'"></div>
                                        <el-button class="disable-command-button" style="width:140px" v-t="'message.action_create_user'"></el-button>
                                    </el-tooltip>
                                </span>
                                <span v-else>
                                    <el-button class="enable-command-button" style="width:140px" v-on:click="addUserCommand()" v-t="'message.action_create_user'"></el-button>
                                </span>
                            </template>
                            <template v-if="showCreateTalkgroupCommand">
                                <span v-if="disableCreateTalkgroup">
                                    <el-tooltip effect="light" placement="top-start" >
                                        <div v-if="appData.csvProcessing" slot="content" style="text-align:left" v-t="'message.error_import_processing'"></div>
                                        <div v-else slot="content" style="text-align:left" v-t="'message.hint_create_group'"></div>
                                        <el-button class="disable-command-button" style="width:140px" v-t="'message.action_create_group'"></el-button>
                                    </el-tooltip>
                                </span>
                                <span v-else>
                                    <span v-if="enableLongTalkgroup">
                                        <div class="dropdownTalkgroup" @mouseenter="showTalkGroup = true" @mouseleave="showTalkGroup = false">
                                            <el-button class="enable-command-button" style="width:140px" v-t="'message.action_create_group'"></el-button>
                                            <div v-if="showTalkGroup" class="dropdownTalkgroup-menu">
                                                <button style="width:180px" v-on:click="addTalkgroupCommand()" v-t="'message.item_talk_talkgroup'"></button>
                                                <button style="width:180px" v-on:click="showConfirmLongTalkgroup()" v-t="'message.item_talk_long_talkgroup'"></button>
                                            </div>
                                        </div>
                                    </span>
                                    <span v-else>
                                        <el-button class="enable-command-button" style="width:140px" v-on:click="addTalkgroupCommand()" v-t="'message.action_create_group'"></el-button>
                                    </span>
                                </span>
                            </template>
                            <span v-if="isTableViewEnable">
                                <template v-if="showAssignmentToTalkgroupCommand">
                                    <span v-if="disableAssignmentToTalkgroup">
                                        <el-tooltip effect="light" placement="top-start" >
                                            <div v-if="appData.csvProcessing" slot="content" style="text-align:left" v-t="'message.error_import_processing'"></div>
                                            <div v-else slot="content" style="text-align:left" v-t="'message.hint_assignment_to_talkgroup'"></div>
                                            <span v-if="selectedTableOption == TABLE_OPTIONS.group" style="display:inline-block">
                                                <el-button class="disable-command-button" style="width:160px" v-t="'message.action_assignment_User'"></el-button>
                                            </span>
                                            <span v-else style="display:inline-block">
                                                <el-button class="disable-command-button" style="width:160px" v-t="'message.action_assignment_to_talkgroup'"></el-button>
                                            </span>
                                        </el-tooltip>
                                    </span>
                                    <span v-else>
                                        <span v-if="selectedTableOption == TABLE_OPTIONS.group">
                                            <el-button class="enable-command-button" style="width:160px" v-on:click="assignmentToTalkgroupCommand()" v-t="'message.action_assignment_User'"></el-button>
                                        </span>
                                        <span v-else>
                                            <el-button class="enable-command-button" style="width:160px" v-on:click="assignmentToTalkgroupCommand()" v-t="'message.action_assignment_to_talkgroup'"></el-button>
                                        </span>
                                    </span>
                                </template>
                                <template v-if="showAssignmentToGroupCommand">
                                    <span v-if="disableAssignmentToTalkgroup">
                                        <el-tooltip effect="light" placement="top-start" >
                                            <div v-if="appData.csvProcessing" slot="content" style="text-align:left" v-t="'message.error_import_processing'"></div>
                                            <div v-else slot="content" style="text-align:left" v-t="'message.hint_assignment_to_talkgroup'"></div>
                                            <el-button class="disable-command-button" style="width:160px" v-t="'message.action_assignment_to_group'"></el-button>
                                        </el-tooltip>
                                    </span>
                                    <span v-else>
                                        <el-button class="enable-command-button" style="width:160px" v-on:click="assignmentToGroupCommand()" v-t="'message.action_assignment_to_group'"></el-button>
                                    </span>
                                </template>

                                <span v-if="selectedTableOption == TABLE_OPTIONS.ipRadioAccount">
                                    <template v-if="showAssignmentSettingToIpRadioCommand">
                                        <span v-if="disableAssignmentToTalkgroup">
                                            <el-tooltip effect="light" placement="top-start" >
                                                <div v-if="appData.csvProcessing" slot="content" style="text-align:left" v-t="'message.error_import_processing'"></div>
                                                <div v-else slot="content" style="text-align:left" v-t="'message.hint_assignment_to_talkgroup'"></div>
                                                <el-button class="disable-command-button" style="width:160px" v-t="'message.common_action_setting_assign'"></el-button>
                                            </el-tooltip>
                                        </span>
                                        <span v-else>
                                            <el-button class="enable-command-button" style="width:160px" v-on:click="assignmentSettingToIpRadioCommand()" v-t="'message.common_action_setting_assign'"></el-button>
                                        </span>
                                    </template>
                                </span>
                            </span>
                            <template v-if="showCreateBuddycomCallUserCommand">
                                <span v-if ="hasBuddycomCallLicence">
                                    <span v-if="disableCreateBuddycomCallUser">
                                    <el-tooltip effect="light" placement="top-start">
                                        <div slot="content" v-t="'message.hint_create_buddycom_call_user'"></div>
                                        <el-button class="disable-command-button" style="width:180px" v-t="'message.action_create_buddycom_call_user'"></el-button>
                                    </el-tooltip>
                                    </span>
                                    <span v-else>
                                        <el-button class="enable-command-button" style="width:180px" v-on:click="addBuddycomCallUserCommand()" v-t="'message.action_create_buddycom_call_user'"></el-button>
                                    </span>
                                </span>
                            </template>
                        </div>
                        <div class="command-area-right">
                            <el-popover placement="left" width="230" trigger="manual" v-model="showCsvProcessing">
                                <div class="csv-progress-title">
                                    {{ csvProcessStatusDescription }}
                                </div>
                                <div v-if="showImportCsvProcess">
                                    <div class="csv-progress-title csv-progress-title-summary">
                                        <span
                                            v-if="csvUnprocessedLineCount > 0">{{ $t("message.info_csv_import_result_with_unprocessed", {
                                            success: csvSuccessLineCount,
                                            error: csvErrorLineCount,
                                            unprocessed: csvUnprocessedLineCount,
                                            total: csvTotalLineCount,
                                        }) }}</span>
                                        <span
                                            v-else-if="csvErrorLineCount > 0">{{ $t("message.info_csv_import_result", {
                                            success: csvSuccessLineCount,
                                            error: csvErrorLineCount,
                                            total: csvTotalLineCount,
                                        }) }}</span>
                                    </div>
                                    <el-progress :text-inside="true" :stroke-width="18" color="#5171cb" text-color="#ffffff" :percentage="csvProgress"></el-progress>
                                    <div v-if="(!csvProcessedAll) && (!csvAborted)"
                                         style="padding:20px 0 0 0;text-align:center">
                                        <el-button class="dialog-small-button" @click="handleCancelImport()"
                                                   :disabled="canceling">
                                            {{ $t("message.action_cancel_process") }}
                                        </el-button>
                                    </div>
                                    <div
                                        v-else-if="(csvErrorLineCount === 0 && csvUnprocessedLineCount === 0) && csvAborted"
                                        style="padding:20px 0 0 0;text-align:center">
                                        <el-button class="dialog-small-button" @click="handleCloseCSVProgress()">
                                            {{ $t("message.button_ok") }}
                                        </el-button>
                                    </div>
                                    <div v-else style="padding:20px 0 0 0;text-align:center">
                                        <el-button class="dialog-small-button" @click="handleCloseCSVProgress()">
                                            {{ csvErrorLineCount === 0 && csvUnprocessedLineCount > 0
                                            ? $t("message.action_confirm_result")
                                            : $t("message.action_confirm_error") }}
                                        </el-button>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="isBatchProcessingVisible"
                                        style="padding:20px 0 0 0;text-align:center"
                                        v-t="displayState">
                                    </div>
                                    <div v-else-if="showExportCsvProcess" style="padding:10px 0;text-align:center" v-t="{ path: 'message.item_csv_execution_time', args: { execTime: csvExportExecTime } }"></div>
                                </div>
                                <button slot="reference" class="transparent" type="button" @click="handleShowCsvDialog()">
                                    <img src="../assets/icon_csv.svg"/><span class="normal-command" v-t="'message.action_csv_import'"></span>
                                </button>
                            </el-popover>
                        </div>
                    </div>
                </td>
            </tr>

            <!-- 表形式 -->
            <tr class="itemheader" style="border:none" v-if="isTableViewEnable">
                <td width=20% height=100%>
                    <div class="inner-panel">
                        <div class="objectTree" @mousedown.capture="markTableTreeManualSelection">
                            <nodeobjecttree
                                v-bind:initialData="appData.tenantList"
                                @on-selectnode="handleOnSelectNode"
                                @changeListType="handleChangeListType"
                                ref="nodeObjectTree"
                            />

                        </div>
                    </div>
                </td>
                <td width=80% height=100%>
                    <div class="inner-panel">
                        <div class="layout-wrapper">
                            <div class="table-title">
                                <div class="table-title-left">
                                    <el-button-group class="object-table">
                                        <el-button
                                            v-for="option in TABLE_OPTIONS"
                                            :key="option.value"
                                            :type="selectedTableOption.value === option.value ? `primary` : `default`"
                                            :plain="selectedTableOption.value !== option.value"
                                            @click="selectTableOption(option)"
                                        >
                                            {{ tableOptionLabels[option.value] }}
                                        </el-button>
                                    </el-button-group>
                                </div>
                                <div>
                                    <button class="transparent-button" type="button" v-on:click="handleColumnConfig"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit_display_items'"></span></button>
                                </div>
                                <div class="table-title-right">
                                    <button v-if="tableSearch == 0" class="tree-command-button" type="button" v-on:click="tableSearch=1"><img src="../assets/loupe.svg" style="height:18px;vertical-align:middle"/>
                                        <div class="tree-command-text" v-t="'message.action_search_items'"></div>
                                    </button>
                                    <button v-if="tableSearch == 1" class="tree-command-button" type="button" v-on:click="tableSearch=0"><img src="../assets/icon_return.svg" style="height:18px;vertical-align:middle"/>
                                        <div class="tree-command-text" v-t="'message.button_back'"></div>
                                    </button>
                                </div>
                            </div>
                            <div v-if="tableSearch == 1" class="table-title" style="height: 56px">
                                <el-form @submit.native.prevent="findTableObject()" style="padding-left: 20px;padding-top:5px">
                                    <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" class="object-search-select" style="padding-left:0px;width:540px;" clearable @clear="searchString=null">
                                        <el-select class="search-item" v-model="condition" slot="prepend">
                                            <el-option
                                                v-for="opt in searchConditions"
                                                :key="opt.value"
                                                style="font-size:12px"
                                                :value="opt.value"
                                                :label="$t(opt.labelKey)"
                                            />
                                        </el-select>
                                        <el-button slot="append" class="search-button" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                    </el-input>
                                </el-form>
                            </div>
                            <objecttable
                                v-bind:objectDataList="objectDataList"
                                v-bind:selectedTableOption="selectedTableOption"
                                v-bind:tableViewColumns="tableViewColumns"
                                v-bind:appData="appData"
                                v-bind:forceIpRadioPreselect="forceIpRadioPreselect"
                                v-bind:currentPage="currentTablePage"
                                @select="handleSelectionColumnChange"
                                @pageChange="handlePageChange"
                                @detailClick="handleDetailClick"
                                ref="objectTable"
                            />
                        </div>
                        <component
                          v-show="false"
                          v-bind:selectedNode="selectedNode"
                          v-bind:appData="appData"
                          v-bind:listType="listType"
                          :is="selectedChild"
                          ref="objectInfo"
                          @setaclinfo="setAclInfo"
                        />
                    </div>
                </td>
            </tr>

            <tr class="itemheader" style="border:none" v-else>
                <td width="50%" height="100%">
                    <div class="inner-panel">
                        <div class="objectTree">
                            <objecttree
                                v-bind:initialData="appData.tenantList"
                                :appData="appData"
                                @on-selectnode="handleOnSelectNode"
                                @changeListType="handleChangeListType"
                                :showAdminUser="true"
                                ref="objectTree">
                            </objecttree>
                        </div>
                    </div>
                </td>
                <td width="50%">
                    <div class="inner-panel">
                        <div class="scrollable">
                            <component
                                v-bind:selectedNode="selectedNode"
                                v-bind:appData="appData"
                                v-bind:listType="listType"
                                :is="selectedChild"
                                ref="objectInfo"
                                @setaclinfo="setAclInfo"
                                @resetSelectedNode="resetSelectedNode"
                                @refresh="handleRefreshObjectTree"
                                @deleted="handleRefreshObjectTree">
                            </component>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
        <confirmDialogLongTalkgroupCreation v-if="showConfirmDialogLongTalkgroupCreation" @confirmed="addLongTalkgroupCommand()" @cancel="showConfirmDialogLongTalkgroupCreation=false"></confirmDialogLongTalkgroupCreation>
        <addgroup v-if="showAddGroup" :appData="appData" :selectedNode="this.selectedNode" :aclInfo="this.aclInfo" @add="addGroup" @cancel="showAddGroup=false"></addgroup>
        <addtalkgroup v-if="showAddTalkgroup" @add="addTalkgroup" @showManual="showManual()" @cancel="showAddTalkgroup=false" :appData=appData></addtalkgroup>
        <adduser v-if="showAddUser" @add="addUser" @cancel="showAddUser=false" :appData=appData></adduser>
        <addbuddycomcalluser v-if="showAddBuddycomCallUser" :appData="appData" @add="addBuddycomCallUser" @cancel="showAddBuddycomCallUser = false"/>
        <addLongTalkgroup v-if="showAddLongTalkgroup" @add="addTalkgroup" @showManual="showManual()" @cancel="showAddLongTalkgroup=false" :appData=appData></addLongTalkgroup>
        <assignmentToTalkgroup v-if="showAssignmentToTalkgroup" @save="assignToTalkgroup" @cancel="showAssignmentToTalkgroup=false" :appData="appData" :selectionColumn="selectionColumn"></assignmentToTalkgroup>
        <assignmentToGroup v-if="showAssignmentToGroup" @save="moveObjectToCreatedGroup" @cancel="showAssignmentToGroup=false" :appData="appData" :selectionColumn="selectionColumn"></assignmentToGroup>
        <assignmentSettingToIpRadio v-if="showAssignmentSettingToIpRadio" @save="assignIPRadioSetting" @cancel="showAssignmentSettingToIpRadio=false" :appData="appData" :selectionColumn="selectionColumn"></assignmentSettingToIpRadio>
        <tabledetaildialog
            v-if="showObjectDialog"
            :appData="appData"
            :id="detailSelection.id"
            :type="detailSelection.type"
            :tenantId="detailSelection.tenantId"
            :name="detailSelection.name"
            :displayName="detailSelection.displayName"
            @refresh="handleTableRefresh"
            @deleted="handleTableRefreshAfterDelete"
            @cancel="closeDetailDialog">
        </tabledetaildialog>
        <importcsv
            v-if="showImportUser"
            ref="refImportcsv"
            :showErrorInfo="showImportError"
            :csvResult="importErrorInfo"
            :batchState="batchState"
            :exportingCsvType="exportingCsvType"
            :userDisplayName="userDisplayName"
            :tenantAdminUser="appData.tenantAdminUser"
            :csvResultCounts="{
                success: csvSuccessLineCount,
                error: csvErrorLineCount,
                skip: csvUnprocessedLineCount,
                total: csvTotalLineCount
            }"
            @import="importUser"
            @export="exportToCsv"
            @end="closeImportModal"
            @check="checkExportRequest"
            @cancel="showImportUser=false"
        ></importcsv>
        <objectTableColumnConfig
            v-if="showObjectTableColumnConfig"
            :currentTableType="selectedTableOption"
            :tableViewColumns="tableViewColumns"
            :appData="appData"
            ref="objectTableColumnConfig"
            @cancel="showObjectTableColumnConfig=false"
            @submit="changeTableViewColumns"></objectTableColumnConfig>
    </div>
</template>

<script>
import constants from './constants.js';
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import InitialUserRightPanel from "./InitialUserRightPanel.vue"
import ObjectTree from "./ObjectTree.vue"
import ObjectTable from "./ObjectTable.vue"
import NodeObjectTree from "./NodeObjectTree.vue"
import NodeObject from "./NodeObject.vue";
import UserObject from "./pc/user-and-group/object/UserObject.vue";
import TalkgroupObject from "./pc/user-and-group/object/TalkgroupObject.vue";
import ChatGPTObject from "./pc/user-and-group/object/ChatGPTObject.vue";
import BuddycomCallUserObject from './buddycomcall/BuddycomCallUserObject.vue';
import IpRadioObject from "./pc/user-and-group/object/IPRadioObject.vue";
import AddGroup from "./AddGroup.vue";
import AddTalkgroup from "./AddTalkgroup.vue";
import AddLongTalkgroup from "./AddLongTalkgroup.vue";
import AddUser from "./AddUser.vue";
import AddBuddycomCallUser from "./buddycomcall/AddBuddycomCallUser.vue";
import ImportCSV from "./ImportCSV.vue";
import AssignmentToTalkgroup from "./AssignmentToTalkgroup.vue";
import AssignmentToGroup from "./AssignmentToGroup.vue";
import AssignmentSettingToIpRadio from './AssignmentSettingToIpRadio.vue';
import AssignIPRadioSetting from './pc/user-and-group/dialog/AssignIPRadioSetting.vue';
import ObjectTableColumnConfig from "./ObjectTableColumnConfig.vue";
import TableDetailDialog from "./pc/user-and-group/table/TableDetailDialog.vue";
import ConfirmDialogLongTalkgroupCreation from './ConfirmDialogLongTalkgroupCreation.vue';
import { FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE } from "@/components/feature_toggles/feature_toggle";

export default {
    data () {
        return {
            // Const
            NO_QUEUE: constants.BATCH_CSV_NO_QUEUE,
            IN_QUEUE: constants.BATCH_CSV_IN_QUEUE,
            PROCESSING: constants.BATCH_CSV_PROCESSING,

            TABLE_OPTIONS: constants.TABLE_OPTIONS,

            showAddGroup: false,
            showAddTalkgroup: false,
            showAddUser: false,
            showAddBuddycomCallUser: false,
            showImportUser: false,
            showImportError: false,
            showAssignmentToTalkgroup:false,
            showAssignmentToGroup:false,
            showAssignmentSettingToIpRadio:false,
            disableCreateGroup: true,
            disableCreateUser: true,
            disableCreateTalkgroup: true,
            disableAssignmentToTalkgroup: true,
            disableCreateBuddycomCallUser: true,
            hasBuddycomCallLicence: false,
            selectedNode: null,
            show: false,
            showTalkGroup: false,
            showCsvProcessing: false,
            showImportCsvProcess: false,
            showExportCsvProcess: false,
            showConfirmDialogLongTalkgroupCreation: false,
            showAddLongTalkgroup: false,
            showObjectDialog: false,
            csvType: "",
            csvProgress: 0,
            csvAborted: false,
            csvSuccessLineCount: 0,
            csvErrorLineCount: 0,
            csvUnprocessedLineCount: 0,
            csvTotalLineCount: 0,
            csvExportExecTime: 0,
            csvProcessedAll: false,
            timerObj: null,
            aclInfo: {
                rw: null,
                ro: null
            },
            listType: 0,
            tableSearch: 0,
            importErrorInfo: null,
            csvProcessStatusDescription: null,
            advancedOnly: false,
            batchState: '',
            exportingCsvType: '',
            userDisplayName: '',
            enableLongTalkgroup: false,

            isTableViewEnable: false,
            objectDataList: { users: [], maxUserTotal: 0, talkGroups: [], maxTalkGroupTotal: 0, ipRadios: [], maxIpRadioTotal: 0},
            tableViewColumns: {},
            selectedTableOption: constants.TABLE_OPTIONS.buddycomAccount,
            showObjectTableColumnConfig: false,
            tableViewColumnsVisible: {
                buddycomAccount: Array(17).fill(true),
                group: Array(8).fill(true),
                ipRadio: Array(11).fill(true),
            },
            // Transition用：初期ロード中はツリーノード選択による通常取得を抑止するためのフラグ
            transitionPending: false,
            // トランジション遷移中は、ツリー選択に伴う通常取得を抑止するフラグ
            skipNextNodeFetch: false,
            tableTreeManualSelection: false,
            // トランジション時のみ IP 無線機のチェック状態維持を有効化
            forceIpRadioPreselect: false,
            selectionColumn: {},
            loadingScreen: null,
            userSpecifiedPage: 1,
            talkgroupSpecifiedPage: 1,
            ipRadioSpecifiedPage: 1,
            searchString: null,
            condition: "userId",
            searchConditions: [],
            detailSelection: {
                id: null,
                type: null,
                tenantId: null,
                name: '',
                displayName: '',
            },
            isLastViewTable: false,
        }
    },
    methods: {
        applyTableOptionState(selectedTableOption) {
            this.selectedTableOption = selectedTableOption;
            this.searchConditions = commonUtil.getSearchCondition(selectedTableOption);
            if (this.searchConditions.length > 0) {
                this.condition = this.searchConditions[0].value;
            }
        },
        resetUserViewState(wasTableView) {
            this.getCsvProcessState();
            this.forceIpRadioPreselect = false;
            this.skipNextNodeFetch = false;
            this.transitionPending = false;
            this.tableTreeManualSelection = false;
            this.selectedNode = null;
            this.selectedTableOption = this.TABLE_OPTIONS.buddycomAccount;
            this.selectionColumn = {};
            this.disableAssignmentToTalkgroup = true;
            this.userSpecifiedPage = 1;
            this.talkgroupSpecifiedPage = 1;
            this.ipRadioSpecifiedPage = 1;
            this.tableSearch = 0;
            this.searchString = null;
            this.searchConditions = commonUtil.getSearchCondition(this.selectedTableOption);
            if (this.searchConditions.length > 0) {
                this.condition = this.searchConditions[0].value;
            }
            this.listType = 0;
            this.showObjectDialog = false;
            this.disableCreateCommand();

            if (wasTableView) {
                this.isTableViewEnable = true;
                this.$nextTick(() => {
                    if (this.$refs.objectTable && typeof this.$refs.objectTable.clearSelection === 'function') {
                        this.$refs.objectTable.clearSelection();
                    }
                    if (this.$refs.nodeObjectTree && typeof this.$refs.nodeObjectTree.autoSelectFirstRoot === 'function') {
                        this.$refs.nodeObjectTree.autoSelectFirstRoot();
                    }
                });
            }else{
                this.isTableViewEnable = false;
                if (this.$refs.objectTree) {
                    this.$refs.objectTree.resetCurrentNode(true);
                } else if (this.$refs.nodeObjectTree && typeof this.$refs.nodeObjectTree.resetCurrentNode === 'function') {
                    this.$refs.nodeObjectTree.resetCurrentNode(true);
                }
            }
        },
        addGroupCommand: function() {
            if (this.checkRwAcl()) {
                this.showAddGroup = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_create_node_denied"));
            }
        },
        addTalkgroupCommand: function() {
            if (this.checkRwAcl()) {
                this.showAddTalkgroup = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_create_group_denied"));
            }
        },
        addLongTalkgroupCommand: function() {
            this.showConfirmDialogLongTalkgroupCreation = false;
            this.$nextTick(() => {
                this.showAddLongTalkgroup = true;
            });
        },
        addUserCommand: function() {
            if (this.appData.tenantList[0].samlLayer != null) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_create_user_enableSAML"));
                return;
            }
            if (this.checkRwAcl()) {
                this.showAddUser = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_create_user_denied"));
            }
        },
        addBuddycomCallUserCommand: function() {
            // TODO: BuddycomCallUser作成のための個別の権限チェックロジックを検討
            if (this.appData.tenantList[0].samlLayer != null) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_create_user_enableSAML"));
                return;
            }
            if (this.checkRwAcl()) {
                this.showAddBuddycomCallUser = true
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_create_user_denied"));
            }
        },
        assignmentToTalkgroupCommand: function() {
            if (this.checkRwAcl()) {
                this.showAssignmentToTalkgroup = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_assignment_to_talkgroup_denied"));
            }
        },
        assignmentToGroupCommand: function() {
            if (!commonUtil.canManageConsoleUserGroupDefinition(this.appData)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_assignment_to_group_denied"));
                return;
            }
            if (this.checkRwAcl()) {
                this.showAssignmentToGroup = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_assignment_to_group_denied"));
            }
        },
        assignmentSettingToIpRadioCommand: function(){
            if (commonUtil.canManageRadioSettingAssignment(this.appData)) {
                this.showAssignmentSettingToIpRadio = true;
                return;
            }

            if (this.checkRwAcl()) {
                this.showAssignmentSettingToIpRadio = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_assignment_to_talkgroup_denied"));
            }
        },
        addGroup: function(input) {
            this.$data.showAddGroup = false;
            if (this.isTableViewEnable) {
                this.addGroupForTable(input);
            }else {
                this.addGroupForTree(input);
            }
        },
        addGroupForTable: async function(input) {
            if (this.selectionColumn.data && this.selectionColumn.data.length > 0) {
                this.displayLoadingScreen();
            }
            try {
                let parentId = this.selectedNode.node.data.id || constants.ROOT_NODE_ID;
                const res = await server.post('/createnode', {
                    operation: {
                        parentId: parentId,
                        name: input.name,
                        acl: input.acl,
                        clientSettingId: input.clientSettingId,
                    }
                });
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_created_layer"));
                    if (this.$refs.nodeObjectTree) {
                        this.$refs.nodeObjectTree.reload();
                    }
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_create_node_denied"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_cannot_create_layer_duplicate"));
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "addGroup").replace("{code}", res.data.status));
                            break;
                    }
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "addGroup", error);
            } finally {
                this.closeLoadingScreen();
            }
        },
        addGroupForTree: async function(input) {
            let nodeToAdd = this.$refs.objectTree.getNodeById(this.selectedNode.node.data.id);
            let [success, createdId] = await this.$refs.objectTree.addGroup(
                {
                    tenantId: this.selectedNode.tenantId,
                    node: nodeToAdd
                },
                input
            );

            if (success && this.$refs.nodeObjectTree) {
                let nodeToAdd = this.$refs.nodeObjectTree.getNodeById(this.selectedNode.node.data.id);

                let insertData = {
                    data:
                        {
                            tenantId: this.selectedNode.tenantId,
                            id: createdId,
                            label: input.name,
                            type: 0,
                            isLeaf: true
                        }
                };
                let insertIndex = this.$refs.nodeObjectTree.getInsertIndexOfNode(nodeToAdd, input.name);

                this.$refs.nodeObjectTree.insertNode(nodeToAdd, insertData, insertIndex)
            }
        },
        moveObjectToCreatedGroup(selectedObject,groupId) {
            // tableView用の処理。選択中 object を指定階層へ移動する。
            if(this.showAssignmentToGroup){
                this.showAssignmentToGroup = false;
            }
            let operations = [];
            for (let object of selectedObject) {
                operations.push({
                    command: "move",
                    operation: {
                        id: object.id ,
                        destinationId: groupId
                    }
                })
            }

            let self = this;

            if (operations.length == 0) {
                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_no_changing_information"));
                return;
            }

            server.post('/multiop', {operations: operations})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"階層への移動が完了しました"));
                            this.disableAssignmentToTalkgroup = true;
                            this.fetchTableDataForCurrentTab();
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            if (res.data.errorInfo.length > 0 && res.data.errorInfo[0].errorCode === constants.STATUS_ERROR_EXCEEDS_MAX_COUNT) {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_in_alert_group_for_exceed"));
                                break;
                            }
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_participated_group_access_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","moveObjectToCreatedGroup").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "moveObjectToCreatedGroup", error);
                });
        },
        addTalkgroup: function(input) {
            this.$data.showAddTalkgroup = false;
            this.$data.showAddLongTalkgroup = false;
            if (this.isTableViewEnable) {
                this.addTalkgroupForTable(input);
            }else {
                this.addTalkgroupForTree(input);
            }
        },
        addTalkgroupForTree(input) {
            let nodeToAdd = this.$refs.objectTree.getNodeById(this.selectedNode.node.data.id);
            this.$refs.objectTree.addTalkgroup(
                {
                    tenantId: this.selectedNode.tenantId,
                    node: nodeToAdd
                },
                input
            );
        },
        addTalkgroupForTable(input){
            this.displayLoadingScreen();
            const self = this;
            let parentId = this.selectedNode.node.data.id || constants.ROOT_NODE_ID;
            server.post('/createtalkgroup', {
                operation: {
                    parentId: parentId,
                    name: input.name,
                    displayName: input.displayName,
                    region: input.region,
                    talkgroupOptions: input.talkgroupOptions,
                    durationLimit: input.durationLimit,
                    videoDurationLimit: input.videoDurationLimit,
                    processorDefinitionIds: input.processorDefinitionIds,
                }
            }).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self, "Success", commonUtil.getMessageText(self.$i18n, "info_created_group"));
                    self.fetchTableDataForCurrentTab();
                    if (self.$refs.nodeObjectTree) {
                        self.$refs.nodeObjectTree.reload();
                    }
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_create_group_denied"));
                            break;
                        case constants.STATUS_ERROR_TOO_MANY_ENTRY:
                            commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_cannot_create_group_exceeds_max"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_group_duplicate"));
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "addTalkgroup").replace("{code}", res.data.status));
                            break;
                    }
                }
            }).catch((error) => {
                commonUtil.putExceptionErrorMessage(self, "addTalkgroup", error);
            }).finally(() => {
                self.closeLoadingScreen();
            });
        },
        addUser: function(input) {
            this.$data.showAddUser = false;
            if (this.isTableViewEnable) {
                this.addUserForTable(input);
            }else {
                this.addUserForTree(input);
            }
        },
        addUserForTree(input) {
            let nodeToAdd = this.$refs.objectTree.getNodeById(this.selectedNode.node.data.id);
            this.$refs.objectTree.addUser(
                {
                    tenantId: this.selectedNode.tenantId,
                    node: nodeToAdd
                },
                input
            );
        },
        // 表形式における /createuser 直接呼び出し用ヘルパー。
        addUserForTable(input) {
            this.displayLoadingScreen();
            const self = this;
            let parentId = this.selectedNode.node.data.id || constants.ROOT_NODE_ID;
            server.post('/createuser', {
                operation: {
                    parentId: parentId,
                    name: input.name,
                    displayName: input.displayName,
                    password: input.password,
                    organization: input.organization,
                    title: input.title,
                    phoneNumber: input.phoneNumber,
                    emailAddress: input.emailAddress,
                    userOptions: input.userOptions,
                }
            }).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self, "Success", commonUtil.getMessageText(self.$i18n, "info_created_user"));
                    self.fetchTableDataForCurrentTab();
                    if (self.$refs.nodeObjectTree) {
                        self.$refs.nodeObjectTree.reload();
                    }
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_create_user_denied"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_user_duplicate"));
                            break;
                        case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_user_insufficient_license"));
                            break;
                        case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_user_insufficient_option"));
                            break;
                        case constants.STATUS_ERROR_CLOSING_RUNNING:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_user_no_contract"));
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "addUser").replace("{code}", res.data.status));
                    }
                }
            }).catch((error) => {
                commonUtil.putExceptionErrorMessage(self, "addUser", error);
            }).finally(() => {
                self.closeLoadingScreen();
            });
        },
        addBuddycomCallUser: function(input) {
            this.showAddBuddycomCallUser = false;
            if (this.isTableViewEnable) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_create_user_denied"));
                return;
            }

            let nodeToAdd = this.$refs.objectTree.getNodeById(this.selectedNode.node.data.id);
            this.$refs.objectTree.addBuddycomCallUser(
                {
                    tenantId: this.selectedNode.tenantId,
                    node: nodeToAdd
                },
                input
            );
        },
        addTalkgroupToCreatedUser(selectedTalkgroup,user) {
            // tableView用の処理。作成した user に選択中 talkgroup を追加する。
            let operations = [];
            for (let talkGroup of selectedTalkgroup) {
                operations.push({
                     command: "addtotalkgroup",
                     operation: {
                         tenantId: this.selectedNode.node.data.tenantId,
                         talkgroupId: talkGroup.id,
                         userTenantId: this.appData.tenantList[0].tenantId,
                         userId: user.id
                     }
                 })
            }

            let self = this;

            if (operations.length == 0) {
                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_no_changing_information"));
                return;
            }

            server.post('/multiop', {operations: operations})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"選択グループにユーザーを追加しました"));
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            if (res.data.errorInfo.length > 0 && res.data.errorInfo[0].errorCode === constants.STATUS_ERROR_EXCEEDS_MAX_COUNT) {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_in_alert_group_for_exceed"));
                                break;
                            }
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_participated_group_access_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addTalkgroupToCreatedUser").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "addTalkgroupToCreatedUser", error);
                });
        },
        exportToCsv: function(exportType, fromAdvanced=false) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this, "Error", "info_csv_exporting");
                return;
            }
            this.csvProcessStatusDescription = commonUtil.getMessageText(this.$i18n,"info_csv_exporting");
            this.showImportUser = false;
            this.csvExportExecTime = 0;
            this.showExportCsvProcess = true;
            let downloadFileName;
            switch(exportType) {
                case "user":
                    downloadFileName = "buddycom_export_user.csv";
                    break;
                case "talkgroup":
                    downloadFileName = "buddycom_export_group.csv";
                    break;
                case "usertalkgroup":
                    downloadFileName = "buddycom_export_usergroup.csv";
                    break;
            }
            this.timerObj = setInterval(function() {self.getCsvProcessState()}, 1000);
            let self = this;
            server.post("/exportcsv", {type: exportType, locale: this.$i18n.locale})
                .then((res) => {
                    self.showExportCsvProcess = false;
                    self.appData.csvProcessing = false;
                    if( typeof res.data.status === 'undefined') {
                        const universalBOM = "\uFEFF";
                        const blob = new Blob([universalBOM + res.data], { type: 'application/csv;charset=UTF-8' })
                        commonUtil.downloadFile(blob, downloadFileName)
                    } else {
                        if (res.data.status === constants.STATUS_ERROR_EXCEEDS_MAX_COUNT) {
                            if (fromAdvanced) {
                                self.exportingCsvType = exportType;
                                self.sendRequestBatchExport(exportType);
                            } else {
                                this.showImportUser = true;
                                self.$nextTick(() => {
                                    self.$refs.refImportcsv.openAdvancedMenu();
                                });
                            }
                        } else if (res.data.status === constants.STATUS_ERROR_PERMISSION_DENIED) {
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_export_denied"));
                        } else {
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","exportToCsv").replace("{code}",res.data.status));
                        }
                    }
                })
                .catch( function ( error ) {
                    self.showExportCsvProcess = false;
                    self.appData.csvProcessing = false;
                    commonUtil.putExceptionErrorMessage(self, "exportToCsv", error);
                });
        },
        async sendRequestBatchExport(type) {
            try {
                const req = {
                    computeType: "export",
                    type: type,
                    locale: this.$i18n.locale
                }
                const res = await server.post("/csvbatchrequestcontroller", req);
                if (res.data.status === constants.STATUS_SUCCESS) {
                    this.batchState = constants.IN_QUEUE;
                    clearInterval(this.timerObj);
                    this.timerObj = null;
                    this.checkExportRequest();
                    commonUtil.notifyMessage(this, "Success", "エクスポート処理を予約しました。");
                } else {
                    commonUtil.notifyMessage(this, "Error", "エクスポート処理を予約できませんでした。");
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "sendRequestBatchExport", error);
            }
        },
        importUser: function(importType , uploadFile) {
            this.showImportUser = false;
            this.csvType = "";
            this.csvProgress = 0;
            this.csvErrorLineCount = 0;
            this.csvSuccessLineCount = 0;
            this.csvUnprocessedLineCount = 0;
            this.csvAborted = false;
            this.canceling = false;
            this.csvProcessedAll = false;
            let param = {
                importType: importType,
                csvFileName: uploadFile.name,
            }
            let self = this;
            server.postWithFile("/importcsv", uploadFile, JSON.stringify(param))
                .then((res) => {
                    let msg;
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.timerObj = setInterval(function() {self.getCsvProcessState()}, 1000)
                            break;
                        case constants.STATUS_BUSY:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_import_processing"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_SIZE:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_upload_file_too_big"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","importUser").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "importUser", error);
                });
        },
        getCsvProcessState() {
            clearInterval(this.timerObj);
            this.timerObj = null;
            let self = this;
            server.post("/getcsvprocstate")
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (res.data.importing && self.isUserMenuCsvProcessType(res.data.importType)) {
                                console.log(self.csvProgress);
                                self.csvType = res.data.importType;
                                self.csvProgress = res.data.progressPercentage;
                                self.csvErrorLineCount = res.data.errorCount;
                                self.csvSuccessLineCount = res.data.successCount ?? 0;
                                self.csvUnprocessedLineCount = res.data.errorInfo.unprocessedLineCount ?? 0;
                                self.csvProcessedAll = (res.data.processedCount == res.data.totalCount);
                                self.csvTotalLineCount = res.data.totalCount;
                                if (self.csvProcessedAll) {
                                    self.appData.csvProcessing = false;
                                    self.resetCsvImportProcess();
                                    switch(res.data.errorInfo.status) {
                                        case constants.STATUS_SUCCESS:
                                            self.showImportCsvProcess = false;
                                            commonUtil.notifyMessage(self, "Success",commonUtil.getMessageText(self.$i18n,"info_import_complete").replace("{resultCount}",res.data.totalCount));
                                            if (self.selectedNode != null) {
                                                if (self.selectedNode.node.data.type === constants.OBJECT_USER || self.selectedNode.node.data.type === constants.OBJECT_TALKGROUP) {
                                                    self.$refs.objectInfo.getInfo();
                                                }
                                            }
                                            self.reloadObjectViews();
                                            break;
                                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                                            self.showImportCsvProcess = false;
                                            commonUtil.notifyMessage(self, "Success",commonUtil.getMessageText(self.$i18n,"info_import_complete_with_error"));
                                            self.reloadObjectViews();
                                            break;
                                        case constants.STATUS_PARTIAL_SUCCESS:
                                            self.csvProcessStatusDescription = self.getImportStatusDescription();
                                            self.importErrorInfo = res.data.errorInfo;
                                            self.showImportCsvProcess = true;
                                            if (self.selectedNode != null) {
                                                if (self.selectedNode.node.data.type === constants.OBJECT_USER || self.selectedNode.node.data.type === constants.OBJECT_TALKGROUP) {
                                                    self.$refs.objectInfo.getInfo();
                                                }
                                            }
                                            self.reloadObjectViews();
                                            break;
                                        default:
                                            self.csvProcessStatusDescription = self.getImportStatusDescription();
                                            self.importErrorInfo = res.data.errorInfo;
                                            if (!self.showImportCsvProcess) {
                                                self.showImportCsvProcess = true;
                                            }
                                    }
                                } else {
                                    let errorInfoStatus = res.data.errorInfo.status;
                                    let resetConditionDictionary = [];
                                    resetConditionDictionary[constants.STATUS_ERROR_EXCEEDS_MAX_COUNT] = commonUtil.getMessageText(self.$i18n, "error_csv_exceeds_limit");
                                    resetConditionDictionary[constants.STATUS_ERROR_TOO_MANY_ENTRY] = commonUtil.getMessageText(self.$i18n, "error_csv_exceeds_data");
                                    resetConditionDictionary[constants.STATUS_ERROR_INVALID_CSV_TEMPLATE] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_template");
                                    resetConditionDictionary[constants.STATUS_ERROR_INVALID_UTF8] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_utf8");
                                    resetConditionDictionary[constants.STATUS_ERROR_INVALID_CSV_FORMAT] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_format");
                                    resetConditionDictionary[constants.STATUS_ERROR_TIMEOUT] = commonUtil.getMessageText(self.$i18n, "error_process_timeout");
                                    resetConditionDictionary[constants.STATUS_ERROR_UNKNOWN] = commonUtil.getMessageText(self.$i18n, "error_csv_unknown").replace("{errorCode}",errorInfoStatus);

                                    if (errorInfoStatus in resetConditionDictionary) {
                                        self.resetCsvImportProcess();
                                        self.appData.csvProcessing = false;
                                        self.csvAborted = true;
                                        self.csvProcessStatusDescription = resetConditionDictionary[errorInfoStatus];
                                        self.importErrorInfo = res.data.errorInfo;
                                        if (!self.showImportCsvProcess) {
                                            self.showImportCsvProcess = true;
                                        }
                                        if(errorInfoStatus === constants.STATUS_ERROR_TIMEOUT){
                                            self.csvSuccessLineCount = res.data.errorInfo.successLineCount ?? 0;
                                            self.csvErrorLineCount = res.data.errorInfo.errorLineInfo.length;
                                            self.csvUnprocessedLineCount = res.data.errorInfo.unprocessedLineCount ?? 0;
                                            self.reloadObjectViews();
                                        }
                                        return;
                                    }

                                    self.appData.csvProcessing = true;
                                    if (!self.showImportCsvProcess) {
                                        self.showImportCsvProcess = true;
                                    }
                                    if (self.timerObj == null) {
                                        self.timerObj = setInterval(function() {self.getCsvProcessState()}, 1000);
                                    }
                                    self.csvProcessStatusDescription = this.getImportStatusDescription();
                                }
                            } else {
                                if (self.showImportCsvProcess) {
                                    self.appData.csvProcessing = false;
                                    self.canceling = false;
                                    if (res.data.errorInfo.status === constants.STATUS_ERROR_ABORT) {
                                        self.importErrorInfo = res.data.errorInfo;
                                        self.csvAborted = true;
                                        self.csvSuccessLineCount = res.data.errorInfo.successLineCount ?? 0;
                                        self.csvErrorLineCount = res.data.errorInfo.errorLineInfo.length;
                                        self.csvUnprocessedLineCount = res.data.errorInfo.unprocessedLineCount ?? 0;
                                        if (self.csvSuccessLineCount > 0) {
                                            self.reloadObjectViews();
                                        }
                                    }
                                    self.csvProcessStatusDescription = this.getImportStatusDescription();
                                }
                            }
                            if (res.data.exporting && self.isUserMenuCsvProcessType(res.data.exportType)) {
                                self.csvExportExecTime = Math.floor((Date.now() - new Date(res.data.exportStartTime).getTime()) / 1000);
                                self.showExportCsvProcess = true;
                                self.appData.csvProcessing = true;
                                if (self.timerObj == null) {
                                    self.timerObj = setInterval(function() {self.getCsvProcessState()}, 1000);
                                }
                            } else {
                                if (self.batchState !== self.NO_QUEUE) {
                                    break;
                                }

                                if (self.showExportCsvProcess) {
                                    self.appData.csvProcessing = false;
                                    self.showExportCsvProcess = false;
                                }
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getCsvProcessState").replace("{code}",res.data.status));
                            self.csvProcessStatusDescription = this.getImportStatusDescription();
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getCsvProcessState", error);
                    clearInterval(self.timerObj);
                    self.timerObj = null;
                });
        },
        isUserMenuCsvProcessType(type) {
            return type === constants.CSV_USER || type === constants.CSV_GROUP || type === constants.CSV_USER_GROUP;
        },
        async checkExportRequest() {
            const req = {
                computeType: "check_export"
            }
            try {
                const res = await server.post("/csvbatchrequestcontroller", req);
                if (res.data.status === constants.STATUS_SUCCESS) {
                    this.batchState = res.data.state.state;
                    switch (this.batchState) {
                        case this.IN_QUEUE:
                        case this.PROCESSING:
                            if (this.timerObj == null) {
                                this.timerObj = setInterval(() => { this.checkExportRequest() }, 20000);
                            }
                            this.appData.csvProcessing = true;
                            this.showExportCsvProcess = true;
                            this.exportingCsvType = res.data.state.csvType
                            this.userDisplayName = res.data.state.userDisplayName
                            this.csvProcessStatusDescription = commonUtil.getMessageText(this.$i18n,"info_csv_exporting");
                            return;
                        default:
                            clearInterval(this.timerObj);
                            this.appData.csvProcessing = false;
                            this.showExportCsvProcess = false;
                  }
                } else {
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","checkExportRequest")
                    .replace("{code}",res.data.status));
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "checkExportRequest", error);
            }
        },
        checkBuddycomCallNumberContract() {
            if (this.appData.enableBuddyComCall || this.appData.enableBuddyComCallTrial) {
                this.hasBuddycomCallLicence = true;
            } else {
                this.hasBuddycomCallLicence = false;
            }
        },
        getImportStatusDescription() {
            if (this.csvAborted) {
                return commonUtil.getMessageText(this.$i18n,"info_csv_import_aborted");
            }
            if (this.csvProcessedAll) {
                return commonUtil.getMessageText(this.$i18n,"info_csv_import_completed");
            }
            if (this.canceling) {
                return commonUtil.getMessageText(this.$i18n,"info_csv_import_aborting");
            }
            return commonUtil.getMessageText(this.$i18n,"info_csv_importing");
        },
        resetCsvImportProcess() {
            let self = this;
            server.post("/changecsvimportprocess",{ type: "RESET", importType: self.csvType })
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                        case constants.STATUS_ERROR_NOT_FOUND:
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","resetCsvImportProcess").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "resetCsvImportProcess", error);
                });
        },
        resetSelectedNode() {
            this.selectedNode = null;
        },
        handleShowCsvDialog() {
            this.showImportError = false;
            this.showImportUser=true
        },
        async handleOnSelectNode(node) {
            this.selectedNode = node;
            // トランジション初期処理中は通常の取得をスキップして、mounted 側の処理に任せる
            if (this.transitionPending) {
                return;
            }
            // トランジション遷移中は、通常のノード選択による一覧更新を抑止する
            if (this.skipNextNodeFetch) {
                if (this.tableTreeManualSelection) {
                    this.skipNextNodeFetch = false;
                    this.tableTreeManualSelection = false;
                    this.forceIpRadioPreselect = false;
                } else {
                    return;
                }
            } else if (this.tableTreeManualSelection) {
                this.tableTreeManualSelection = false;
                this.forceIpRadioPreselect = false;
            }

            if (this.isTableViewEnable) {
                this.displayLoadingScreen();
                this.userSpecifiedPage = 1;
                this.talkgroupSpecifiedPage = 1;
                this.ipRadioSpecifiedPage = 1;

                let children = await server.post("/getchildren", {tenantId: this.selectedNode.node.data.tenantId, parentId: this.selectedNode.node.data.id, type: -1})
                if (children.data.status === constants.STATUS_ERROR_DENIED) {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_expand_layer_denied"));

                    this.objectDataList = {
                        users: [],
                        maxUserTotal: 0,
                        talkGroups: [],
                        maxTalkGroupTotal: 0,
                        ipRadios: [],
                        maxIpRadioTotal: 0,
                    };

                    this.$refs.objectTable.reload();
                    this.enableCreateCommand();
                    this.closeLoadingScreen();
                    return;
                }

                const { userIdList, talkgroupIdList, ipRadioIdList } = this.buildIdLists(children);
                let res = await server.post("/gettablerecordlist",
                    {
                            tenantId: this.selectedNode.node.data.tenantId,
                            userIdList, talkgroupIdList, ipRadioIdList
                        }
                );

                if (!res) {
                    return;
                }

                if (res.data.status === constants.STATUS_SUCCESS) {
                    this.objectDataList = {
                        users: res.data.userList,
                        maxUserTotal: res.data.maxUserTotal,
                        talkGroups: res.data.talkGroupList,
                        maxTalkGroupTotal: res.data.maxTalkGroupTotal,
                        ipRadios: res.data.ipRadioList,
                        maxIpRadioTotal: res.data.maxIpRadioTotal,
                    };
                } else if (res.data.status === constants.STATUS_ERROR_NO_CONTENTS) {
                    this.objectDataList = {
                        users: [],
                        maxUserTotal: 0,
                        talkGroups: [],
                        maxTalkGroupTotal: 0,
                        ipRadios: [],
                        maxIpRadioTotal: 0,
                    };
                }

                this.$refs.objectTable.reload();
                this.enableCreateCommand();
                this.closeLoadingScreen();
            }
        },
        markTableTreeManualSelection() {
            this.tableTreeManualSelection = true;
        },
        buildIdLists(children){
            const userIdList = commonUtil.getUserIdList(children.data.userInfos);
            const ipRadioIdList = commonUtil.getIpRadioIdList(children.data.ipRadioInfos);
            const talkgroupIdList = commonUtil.getTalkgroupIdList(children.data.talkGroupInfos);
            return {userIdList, talkgroupIdList, ipRadioIdList};
        },
        handleChangeListType(type) {
            if (type == 1) {
                this.disableCreateGroup = true;
                this.disableCreateUser = true;
                this.disableCreateTalkgroup = true;
                this.disableAssignmentToTalkgroup = true;
                if (this.hasBuddycomCallLicence) {
                    this.disableCreateBuddycomCallUser = true;
                }
            }
            this.listType = type;
        },
        handleCloseCSVProgress() {
            this.showImportCsvProcess = false;
            if (this.csvErrorLineCount > 0 || this.csvUnprocessedLineCount > 0) {
                this.showImportError = true;
                this.showImportUser = true
            }
        },
        handleCancelImport() {
            this.canceling = true;
            this.csvProcessStatusDescription = this.getImportStatusDescription();
            let self = this;
            server.post("/changecsvimportprocess",{ type: "ABORT", importType: self.csvType })
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleCancelImport").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "handleCancelImport", error);
                });
        },
        checkRwAcl() {
            if (this.aclInfo.rw != null) {
                for (let acluser of this.aclInfo.rw) {
                    if (acluser.userName == this.appData.loginId.split("@")[0]) {
                        return true;
                    }
                }
            }
            return false;
        },
        setAclInfo(aclType , aclInfo) {
            if (aclType == 0 ) {
                this.aclInfo.ro = aclInfo;
            } else {
                this.aclInfo.rw = aclInfo;
            }
        },
        showConfirmLongTalkgroup(){
            if (this.checkRwAcl()) {
                this.showConfirmDialogLongTalkgroupCreation = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_create_group_denied"));
            }
        },
        enableCreateCommand() {
            this.disableCreateGroup = false;
            this.disableCreateTalkgroup = false;
            this.disableCreateUser = false;
            if (this.hasBuddycomCallLicence) {
                    this.disableCreateBuddycomCallUser = false;
            }
        },
        disableCreateCommand() {
            this.disableCreateGroup = true;
            this.disableCreateTalkgroup = true;
            this.disableCreateUser = true;
            this.disableAssignmentToTalkgroup = true;
            if (this.hasBuddycomCallLicence) {
                this.disableCreateBuddycomCallUser = true;
            }
        },
        handleRefreshObjectTree() {
            if (this.$refs.objectTree) {
                this.$refs.objectTree.reload();
            }
        },
        handleViewModeChange(isTableView) {
            // トランジション初期処理中は通常の取得を抑止する
            if (this.transitionPending) {
                return;
            }
            this.skipNextNodeFetch = false;
            this.forceIpRadioPreselect = false;
            this.resetSelectedNode()
            // 切替後にどちらのツリーが描画されているかは Vue の差分更新次第なので、両方の ref を考慮する。
            if (this.$refs.objectTree) {
                this.$refs.objectTree.reload();
            }
            if (this.$refs.nodeObjectTree) {
                this.$refs.nodeObjectTree.reload();
            }
            this.disableCreateCommand();
            if (isTableView !== null && isTableView === true) {
                this.fetchTableDataForCurrentTab();
            }
        },
        waitSelectedNodeThen(callback) {
            if (this.selectedNode && this.selectedNode.node && this.selectedNode.node.data) {
                try { callback(); } catch (e) {}
            } else {
                setTimeout(() => this.waitSelectedNodeThen(callback), 50);
            }
        },
        // ObjectTable 側での事前選択を安全にトリガーする（$refs 準備遅延に備えてリトライ）
        triggerPreselectWithRetry(attempt = 0) {
            const MAX_ATTEMPTS = 10;
            const RETRY_DELAY = 50;
            this.$nextTick(() => {
                const table = this.$refs.objectTable;
                if (table && typeof table.applyIpRadioPreselection === 'function') {
                    console.debug('[User] triggerPreselectWithRetry: apply preselection. attempt=', attempt);
                    try { table.applyIpRadioPreselection(); } catch (e) {}
                } else if (attempt < MAX_ATTEMPTS) {
                    setTimeout(() => this.triggerPreselectWithRetry(attempt + 1), RETRY_DELAY);
                } else {
                    console.debug('[User] triggerPreselectWithRetry: give up. refs not ready');
                }
            });
        },
        handleColumnConfig() {
            this.showObjectTableColumnConfig = true;
        },
        getExpireDateTime() {
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
                return new Date(this.appData.basicContract.startDatetime).toLocaleString();
            } else {
                return new Date(this.appData.basicContract.nextFlushDatetime).toLocaleString();
            }
        },
        isExpireTrialContract() {
            if ((this.appData.basicContract != null) && (this.appData.basicContract.state == constants.CONTRACT_TRIAL_END)) {
                return true;
            } else {
                return false;
            }
        },
        isExpirePurchasedContract() {
            if ((this.appData.basicContract != null) && (this.appData.basicContract.state == constants.CONTRACT_TERMINATE)) {
                return true;
            } else {
                return false;
            }
        },
        isBillingPaper() {
            if ((this.appData.basicContract != null) && (this.appData.basicContract.billingType == constants.BILLING_PAPER)) {
                return true;
            } else {
                return false;
            }
        },
        showManual() {
            this.showAddTalkgroup = false;
            this.appData.selectedMenu = "manual";
            this.$router.push({path: "/manual" , query: {item: "externalService"}})
        },
        closeImportModal() {
            this.showImportUser = false;
        },
        selectTableOption(selectedTableOption) {
            this.applyTableOptionState(selectedTableOption);
            this.forceIpRadioPreselect = false;
            //タブ切り替え時選択項目のリセット
                this.resetTableSelection();
                this.searchConditions = commonUtil.getSearchCondition(selectedTableOption);
                if (this.searchConditions.length > 0) {
                    this.condition = this.searchConditions[0].value;
                }
            // タブ切り替え時にデータを取得
            if (this.isTableViewEnable && this.selectedNode) {
                this.userSpecifiedPage = 1;
                this.talkgroupSpecifiedPage = 1;
                this.ipRadioSpecifiedPage = 1;
                this.fetchTableDataForCurrentTab();
            }
        },
        // 現在選択されているタブに応じたデータを取得してテーブルに割り当てる
        async fetchTableDataForCurrentTab() {
            const tenantId = this.selectedNode?.node?.data?.tenantId;
            const parentId = this.selectedNode?.node?.data?.id;
            if (!tenantId || !parentId) {
                return;
            }

            // タブに応じて呼び出すAPIリクエスト内容をを切り替え
            let type = -1;
            const tableOpts = constants.TABLE_OPTIONS;
            if (this.selectedTableOption === tableOpts.buddycomAccount) {
                type = constants.OBJECT_USER;
            } else if (this.selectedTableOption === tableOpts.group) {
                type = constants.OBJECT_TALKGROUP;
            } else if (this.selectedTableOption === tableOpts.ipRadioAccount) {
                type = constants.OBJECT_IP_RADIO;
            }

            this.displayLoadingScreen();

            let children = await server.post("/getchildren", {tenantId: this.selectedNode.node.data.tenantId, parentId: this.selectedNode.node.data.id, type: type})
            if (children.data.status === constants.STATUS_ERROR_DENIED) {
                commonUtil.notifyMessage(this, "Warning", "選択された階層に読み込み権限がないため、情報が読み込めません。");

                this.objectDataList = {
                    users: [],
                    maxUserTotal: 0,
                    talkGroups: [],
                    maxTalkGroupTotal: 0,
                    ipRadios: [],
                    maxIpRadioTotal: 0,
                };

                this.$refs.objectTable.reload();
                this.closeLoadingScreen();
                return;
            }

            const { userIdList, talkgroupIdList, ipRadioIdList } = this.buildIdLists(children);

            let res = await server.post("/gettablerecordlist",
                {
                        tenantId: this.selectedNode.node.data.tenantId,
                        userIdList, talkgroupIdList, ipRadioIdList,
                        userSpecifiedPage:this.userSpecifiedPage,
                        talkgroupSpecifiedPage:this.talkgroupSpecifiedPage,
                        ipRadioSpecifiedPage:this.ipRadioSpecifiedPage

                }
            )

            this.applyTableRecordListResponse(res.data);

            this.$refs.objectTable.reload();
            this.closeLoadingScreen();
        },
        applyTableRecordListResponse(data) {
            if (data.status === constants.STATUS_SUCCESS) {
                this.objectDataList = {
                    users: data.userList,
                    maxUserTotal: data.maxUserTotal,
                    talkGroups: data.talkGroupList,
                    maxTalkGroupTotal: data.maxTalkGroupTotal,
                    ipRadios: data.ipRadioList,
                    maxIpRadioTotal: data.maxIpRadioTotal,
                };
            } else if (data.status === constants.STATUS_ERROR_NO_CONTENTS) {
                this.objectDataList = {
                    users: [],
                    maxUserTotal: 0,
                    talkGroups: [],
                    maxTalkGroupTotal: 0,
                    ipRadios: [],
                    maxIpRadioTotal: 0,
                };
            }
        },
        handleSelectionColumnChange: function(selectionColumn,selectionColumnType){
            this.selectionColumn = {data:selectionColumn, type:selectionColumnType, tableView: this.isTableViewEnable}
            if(!selectionColumn || selectionColumn.length === 0){
                this.disableAssignmentToTalkgroup = true;
            }else{
                this.disableAssignmentToTalkgroup = false;
            }
        },
        resetTableSelection() {
            this.selectionColumn = {};
            this.disableAssignmentToTalkgroup = true;
            if (this.$refs.objectTable && typeof this.$refs.objectTable.clearSelection === 'function') {
                this.$refs.objectTable.clearSelection();
            }
        },
        reloadCurrentTableData() {
            if (this.tableSearch === 1) {
                this.findTableObject({ resetPage: false });
            }else {
                this.fetchTableDataForCurrentTab();
            }
        },
        reloadObjectViews() {
            if (this.isTableViewEnable) {
                if (this.$refs.nodeObjectTree) {
                    this.$refs.nodeObjectTree.reload();
                }
                this.fetchTableDataForCurrentTab();
            } else {
                if (this.$refs.objectTree) {
                    this.$refs.objectTree.reload();
                }
            }
        },
        displayLoadingScreen(){
            this.loadingScreen = this.$loading({
                lock: true,
                text: 'Loading data ...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
            });
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        handlePageChange(newPage,type){
            if(type == this.TABLE_OPTIONS.buddycomAccount.value){
                this.userSpecifiedPage = newPage;
            }else if(type == this.TABLE_OPTIONS.group.value){
                this.talkgroupSpecifiedPage = newPage;
            }else if(type == this.TABLE_OPTIONS.ipRadioAccount.value){
                this.ipRadioSpecifiedPage = newPage;
            }
            this.reloadCurrentTableData();
        },
        handleDetailClick(row, type) {
            const tenantId = this.selectedNode.node.data.tenantId
                ?? this.appData.tenantList[0].tenantId
                ?? null;
            this.detailSelection = {
                id: row.id,
                type: type,
                tenantId: tenantId,
                name: row.name || row.userName || row.talkgroupName || '',
                displayName: row.displayName || '',
            };
            this.showObjectDialog = true;
        },
        handleTableRefresh() {
            this.reloadCurrentTableData();
        },
        handleTableRefreshAfterDelete() {
            this.closeDetailDialog();
            this.resetTableSelection();
            this.reloadCurrentTableData();
        },
        async assignToTalkgroup(addTagList, selectedTagList, selectType){
            this.showAssignmentToTalkgroup = false;
            this.displayLoadingScreen();
            let operations = [];
            let multiOperations = [];

            if (selectType === constants.TABLE_OPTIONS.group.value){
                let maxOp = 1000 - selectedTagList.length;
                for (let key in addTagList) {
                    let tag = addTagList[key];
                    for (let talkgroupKey in selectedTagList){
                        let talkgroupTag = selectedTagList[talkgroupKey];
                        operations.push({
                            command: "addtotalkgroup",
                            operation: {
                                tenantId: this.appData.tenantList[0].tenantId,
                                talkgroupId: talkgroupTag.id,
                                userTenantId: tag.tenantId,
                                userId: tag.userId,
                                permitAlreadyExisted: true
                            }
                        });
                    }
                    if (operations.length >= maxOp){
                        multiOperations.push(operations);
                        operations = [];
                    }
                }
            } else {
                let maxOp = 1000 - addTagList.length;
                for (let key in selectedTagList) {
                    let tag = selectedTagList[key];
                    for (let talkgroupKey in addTagList){
                        let talkgroupTag = addTagList[talkgroupKey];
                        operations.push({
                            command: "addtotalkgroup",
                            operation: {
                                tenantId: this.appData.tenantList[0].tenantId,
                                talkgroupId: talkgroupTag.talkgroupId,
                                userTenantId: this.appData.tenantList[0].tenantId,
                                userId: tag.id,
                                permitAlreadyExisted: true
                            }
                        });
                    }
                    if (operations.length >= maxOp){
                        multiOperations.push(operations);
                        operations = [];
                    }
                }
            }

            if (operations.length > 0){
                multiOperations.push(operations);
            }

            if (multiOperations.length === 0 || multiOperations[0].length === 0) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                this.closeLoadingScreen();
                return;
            }

            try {
                for (let targetOperation of multiOperations){
                    const res = await server.post('/multiop', {operations: targetOperation});
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            if (res.data.errorInfo.length > 0) {
                                let errorCode = res.data.errorInfo[0].errorCode;

                                if (errorCode === constants.STATUS_ERROR_EXCEEDS_MAX_COUNT) {
                                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_modify_user_in_alert_group_for_exceed"));
                                } else if (errorCode === constants.STATUS_ERROR_TALKGROUP_NOT_FOUND) {
                                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_object_not_found_talkgroup"));
                                } else if (errorCode === constants.STATUS_ERROR_USER_NOT_FOUND) {
                                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_object_not_found_user"));
                                } else if (errorCode === constants.STATUS_ERROR_PERMISSION_DENIED) {
                                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_userGroup_of_other_tenant"));
                                } else if (errorCode === constants.STATUS_ERROR_OPTION_UNMATCH) {
                                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_object_option_unmatch"));
                                } else {
                                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","assignToTalkgroup").replace("{code}",res.data.status + "-" + errorCode));
                                }
                            }
                            this.closeLoadingScreen();
                            return;
                        default:
                            commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","assignToTalkgroup").replace("{code}",res.data.status));
                            this.closeLoadingScreen();
                            return;
                    }
                    if (targetOperation !== multiOperations[multiOperations.length - 1]){
                        await new Promise(resolve => setTimeout(resolve, 5000));
                    }
                }
                commonUtil.notifyMessageWithDuration(this, "Success", commonUtil.getMessageText(this.$i18n,"info_modified_participated_user_of_group"), 5000);
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "assignToTalkgroup", error);
                this.closeLoadingScreen();
                return;
            }
            this.disableAssignmentToTalkgroup = true;
            this.fetchTableDataForCurrentTab();
            this.$refs.nodeObjectTree.reload();
            this.closeLoadingScreen();
        },
        async assignIPRadioSetting(settingId, selectIdList) {
            let response
            try {
                response = await server.post('/assignsettingtoipradio',
                {
                        ipRadioSettingId: settingId,
                        ipRadioList: selectIdList
                    })
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "assignIPRadioSetting", error);
            }

            if (!response) {
                return;
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n,"info_modified_assignment_ipradio_setting"));
                    this.disableAssignmentToTalkgroup = true;
                    this.reloadCurrentTableData();
                    break;
                case constants.STATUS_ERROR_NOT_FOUND:
                    commonUtil.notifyMessage(this, "Warning", "指定された無線機設定がありません。");
                    break;
                case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                    commonUtil.notifyMessage(this, "Warning", "指定されたユーザーが存在しません。");
                    break;
                default:
                    commonUtil.putExceptionErrorMessage(this, "updateSetting", response.data.status);
                    break;
            }
            this.showAssignmentSettingToIpRadio = false;
        },
        async findTableObject({ resetPage = true } = {}) {
            if (resetPage) {
                    this.userSpecifiedPage = 1;
                    this.talkgroupSpecifiedPage = 1;
                    this.ipRadioSpecifiedPage = 1;
            }
            let param = {tenantId: this.appData.tenantList[0].tenantId}
            let postUrl;
            switch(this.selectedTableOption){
                case this.TABLE_OPTIONS.buddycomAccount:
                    if (this.condition == "userId") {
                        param.name = this.searchString;
                    } else if (this.condition == "userName") {
                        param.displayName = this.searchString;
                    } else if (this.condition == "organization") {
                        if (this.searchString != "") {
                            param.organization = this.searchString;
                        }
                    } else if (this.condition == "title") {
                        if (this.searchString != "") {
                            param.title = this.searchString;
                        }
                    } else if (this.condition == "phone") {
                        if (this.searchString != "") {
                            param.phone = this.searchString;
                        }
                    }
                    postUrl = "/finduser";
                    break;
                case this.TABLE_OPTIONS.group:
                    if (this.condition == "groupId") {
                        param.name = this.searchString;
                    } else if (this.condition == "groupName") {
                        param.displayName = this.searchString;
                    }
                    postUrl = "/findgroup";
                    break;
                case this.TABLE_OPTIONS.ipRadioAccount:
                    if (this.condition == "userId") {
                        param.name = this.searchString;
                    } else if (this.condition == "userName") {
                        param.displayName = this.searchString;
                    } else if (this.condition == "organization") {
                        if (this.searchString != "") {
                            param.organization = this.searchString;
                        }
                    } else if (this.condition == "title") {
                        if (this.searchString != "") {
                            param.title = this.searchString;
                        }
                    } else if (this.condition == "modelName") {
                        if (this.searchString != "") {
                            param.modelName = this.searchString;
                        }
                    } else if (this.condition == "destinationCode") {
                        if (this.searchString != "") {
                            param.destinationCode = this.searchString;
                        }
                    } else if (this.condition == "serialNumber") {
                        if (this.searchString != "") {
                            param.serialNumber = this.searchString;
                        }
                    } else if (this.condition == "contractNumber") {
                        if (this.searchString != "") {
                            param.contractNumber = this.searchString;
                        }
                    } else if (this.condition == "primaryLine" && !FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE) {
                        if (this.searchString != "") {
                            let primaryLine = commonUtil.getIpRadioPrimaryLineList();
                            let targetPrimaryLineList = primaryLine
                                .filter(v => v.value.includes(this.searchString))
                                .map(v => v.key);
                            if (targetPrimaryLineList.length > 0) {
                                param.primaryLineList = targetPrimaryLineList;
                            } else {
                                param.primaryLineList = [-1];
                            //     検索文字列がどの使用回線にも引っかからない時、-1を入れて検索し、0件で返している。
                            }
                        }
                    } else if (this.condition == "currentLine" && FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE) {
                        if (this.searchString != "") {
                            let primaryLine = commonUtil.getIpRadioPrimaryLineList();
                            let targetPrimaryLineList = primaryLine
                                .filter(v => v.value.includes(this.searchString))
                                .map(v => v.key);
                            if (targetPrimaryLineList.length > 0) {
                                param.currentLineList = targetPrimaryLineList;
                            } else {
                                param.currentLineList = [-1];
                                //     検索文字列がどの使用回線にも引っかからない時、-1を入れて検索し、0件で返している。
                            }
                        }
                    } else if (this.condition == "version") {
                        if (this.searchString != "") {
                            param.version = this.searchString;
                        }
                    } else if (this.condition == "settingName") {
                        if (this.searchString != "") {
                            param.settingName = this.searchString;
                        }
                    } else if (this.condition == "customField1") {
                        if (this.searchString != "") {
                            param.customField1 = this.searchString;
                        }
                    } else if (this.condition == "managementNumber") {
                        if (this.searchString != "") {
                            param.managementNumber = this.searchString;
                        }
                    } else if (this.condition == "planName") {
                        if (this.searchString != "") {
                            param.planName = this.searchString;
                        }
                    } else if (this.condition == "optionName") {
                        if (this.searchString != "") {
                            param.optionName = this.searchString;
                        }
                    }
                    postUrl = "/findipradio";
                    break;
            }
            const searchResult = await server.post(postUrl, param)
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(this, "findObject", error);
                    this.closeLoadingScreen();
                    return;
                });
            if (!searchResult) {
                return;
            }

            let talkgroupIdList = [];
            let ipRadioIdList = [];
            let userIdList = [];
            if (searchResult.data.status == constants.STATUS_SUCCESS) {
                if (postUrl == "/finduser") {
                    userIdList = commonUtil.getUserIdList(searchResult.data.userInfo);
                } else if (postUrl == "/findgroup") {
                    talkgroupIdList = commonUtil.getTalkgroupIdList(searchResult.data.groupInfo);
                } else if (postUrl == "/findipradio") {
                    ipRadioIdList = commonUtil.getIpRadioIdList(searchResult.data.ipRadioInfo);
                }
            } else {
                commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","findObject").replace("{code}",searchResult.data.status));
                return;
            }

            const tableResult = await server.post("/gettablerecordlist", {
                tenantId: this.appData.tenantList[0].tenantId,
                userIdList,
                talkgroupIdList,
                ipRadioIdList,
                userSpecifiedPage: this.userSpecifiedPage,
                talkgroupSpecifiedPage: this.talkgroupSpecifiedPage,
                ipRadioSpecifiedPage: this.ipRadioSpecifiedPage
            }).catch((error) => {
                commonUtil.putExceptionErrorMessage(this, "findObject", error);
                this.closeLoadingScreen();
                return;
            });
            if (!tableResult) {
                return;
            }

            this.applyTableRecordListResponse(tableResult.data);
            this.$refs.objectTable.reload();
            this.enableCreateCommand();
            this.closeLoadingScreen();
        },
        changeTableViewColumns(){
            this.showObjectTableColumnConfig = false;
            this.$refs.objectTable.reload();
        },
        getTableViewColumns() {
            const defaultColumn = commonUtil.getTableColumns();

            if(!this.appData.tenantList[0] || this.appData.loginUserObjectId === 0){
                return defaultColumn;
            }

            const param = {
                tenantId: this.appData.tenantList[0].tenantId,
                id: this.appData.loginUserObjectId
            };

            return server.post('/gettableviewcolumns', param)
                .then((res) => {
                    if (res.data.status === 0) {
                        return {
                            buddycomAccount: JSON.parse(res.data.tableColumnMap.buddycomAccount),
                            ipRadio: JSON.parse(res.data.tableColumnMap.ipRadio),
                            group: JSON.parse(res.data.tableColumnMap.group)
                        };
                    } else if (res.data.status === constants.STATUS_ERROR_NOT_FOUND) {
                        return defaultColumn;
                    }
                })
                .catch((error) => {
                    return defaultColumn;
                });
        },
        loadTableViewColumns() {
            this.getTableViewColumns().then((resultColumns) => {
                this.tableViewColumns = resultColumns;
                this.updateCustomFieldName(this.appData.customFieldName);
            });
        },
        updateCustomFieldName(newVal){
            if (newVal != null) {
                for(let column of this.tableViewColumns.ipRadio){
                    if(column.prop === "customField1"){
                        column.label = newVal;
                    }
                }
            }
        },
        closeDetailDialog(){
            this.showObjectDialog = false;
        },
    },
    components: {
        objecttree: ObjectTree,
        nodeobjecttree: NodeObjectTree,
        objecttable: ObjectTable,
        addgroup: AddGroup,
        addtalkgroup: AddTalkgroup,
        adduser: AddUser,
        addbuddycomcalluser: AddBuddycomCallUser,
        importcsv: ImportCSV,
        UserObject: UserObject,
        NodeObject: NodeObject,
        TalkgroupObject: TalkgroupObject,
        InitialUserRightPanel: InitialUserRightPanel,
        ChatGPTObject: ChatGPTObject,
        BuddycomCallUserObject: BuddycomCallUserObject,
        confirmDialogLongTalkgroupCreation: ConfirmDialogLongTalkgroupCreation,
        addLongTalkgroup: AddLongTalkgroup,
        IpRadioObject: IpRadioObject,
        assignmentToTalkgroup: AssignmentToTalkgroup,
        assignmentToGroup: AssignmentToGroup,
        assignmentSettingToIpRadio: AssignmentSettingToIpRadio,
        objectTableColumnConfig: ObjectTableColumnConfig,
        AssignIPRadioSetting,
        tabledetaildialog: TableDetailDialog,
    },
    computed: {
        showCreateGroupCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showCreateUserCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showCreateTalkgroupCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showCreateBuddycomCallUserCommand() {
            return this.hasBuddycomCallLicence
                && !this.isTableViewEnable
                && commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showAssignmentToTalkgroupCommand() {
            return commonUtil.canManageConsoleUserTalkgroupAssignment(this.appData);
        },
        showAssignmentToGroupCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showAssignmentSettingToIpRadioCommand() {
            return commonUtil.canManageRadioSettingAssignment(this.appData);
        },
        selectedChild: function() {
            if (this.selectedNode != null) {
                switch (this.selectedNode.node.data.type) {
                    case constants.OBJECT_NODE:
                        if (this.appData.csvProcessing) {
                            this.disableCreateCommand();
                        } else {
                            this.enableCreateCommand();
                        }
                        return "NodeObject";
                    case constants.OBJECT_USER:
                        this.disableCreateCommand();
                        return "UserObject";
                    case constants.OBJECT_TALKGROUP:
                        this.disableCreateCommand();
                        return "TalkgroupObject";
                    case constants.OBJECT_BUDDYCOM_CALL_USER:
                        this.disableCreateCommand()
                        return "BuddycomCallUserObject"
                    case constants.OBJECT_ASSISTANT:
                    case constants.OBJECT_CUSTOM_ASSISTANT:
                    // this.disableCreateCommand();
                    // return "ChatGPTObject";
                        break;
                    case constants.OBJECT_IP_RADIO:
                        this.disableCreateCommand();
                        if(this.appData.isRadioIntegrated){
                            return "IpRadioObject";
                        }
                }
            }
            this.$data.showAddButtons = false;
            this.appData.selectedMenu = 'user';
            return "InitialUserRightPanel";
        },
        displayState() {
            switch (this.batchState) {
                case this.IN_QUEUE:
                    return this.userDisplayName + 'がリクエスト中'
                case this.PROCESSING:
                    return 'バッチ処理中'
            }
        },
        isBatchProcessingVisible() {
            return (
                this.batchState === this.IN_QUEUE ||
                this.batchState === this.PROCESSING
            );
        },
        tableOptionLabels() {
            return {
                [this.TABLE_OPTIONS.buddycomAccount.value]: this.$t('message.item_buddycom_account'),
                [this.TABLE_OPTIONS.ipRadioAccount.value]: this.$t('message.item_ip_radio_account'),
                [this.TABLE_OPTIONS.group.value]: this.$t('message.item_group')
            };
        },
        currentTablePage() {
            const selectedValue = this.selectedTableOption?.value;
            if (selectedValue === this.TABLE_OPTIONS.buddycomAccount.value) {
                return this.userSpecifiedPage;
            }
            if (selectedValue === this.TABLE_OPTIONS.group.value) {
                return this.talkgroupSpecifiedPage;
            }
            if (selectedValue === this.TABLE_OPTIONS.ipRadioAccount.value) {
                return this.ipRadioSpecifiedPage;
            }
            return 1;
        }
    },
    created: function() {
        this.getCsvProcessState();
        this.checkBuddycomCallNumberContract();
        this.applyTableOptionState(this.TABLE_OPTIONS.buddycomAccount);
        this.loadTableViewColumns();
    },
    mounted: function() {
        // 表形式時は objectTree が存在しないため、左側ツリー（NodeObjectTree）の有無も確認する。
        if (typeof this.$refs.objectTree === "undefined" && typeof this.$refs.nodeObjectTree === "undefined") {
            // should reDraw to load tree because the tree has destroyed when refreshing on the other menu item.
            this.show = false;
            this.$nextTick(() => {
                 if ((this.appData.tenantList != null) && (this.appData.basicContract != null)) {
                    this.show = true
                    this.$nextTick(() => {
                        this.checkExportRequest();
                        this.getCsvProcessState();
                    });
                 }
            });
        }

        if (sessionStorage.getItem('isTransition')) {
            // 画面初期表示時のトランジション専用処理
            console.log("mounted");
            this.applyTableOptionState(constants.TABLE_OPTIONS.ipRadioAccount); // IP無線機タブに切替
            this.isTableViewEnable = true; // 表形式をON
            this.transitionPending = true; // 初期ロード中はツリー選択による通常取得を抑止
            this.skipNextNodeFetch = true; // トランジション遷移中はツリー選択に伴う通常取得をスキップして、上書きを防止
            this.forceIpRadioPreselect = true;

            const tenantName = this.appData.loginId.split("@")[1];
            if (tenantName) {
                server.post('/gettransitionselectedipradios', { tenantName })
                    .then((res) => {
                        const list = res?.data?.ipRadioList || [];
                        if (res?.data?.status === constants.STATUS_SUCCESS && list.length > 0) {
                            // 取得できた場合：取得できた IP無線機のみを表示し、チェックをON（ObjectTable側で全選択適用）
                            this.objectDataList = { users: [], maxUserTotal: 0, talkGroups: [], maxTalkGroupTotal: 0, ipRadios: list, maxIpRadioTotal: list.length};
                            // 明示トリガー（保険）。$refs準備の遅延に備えてリトライ
                            this.triggerPreselectWithRetry(0);
                        } else {
                            // 取得できなかった場合：通常の取得にフォールバック（トップノード自動選択後）
                            this.forceIpRadioPreselect = false;
                            this.objectDataList = { users: [], maxUserTotal: 0, talkGroups: [], maxTalkGroupTotal: 0, ipRadios: [], maxIpRadioTotal: 0};
                            this.waitSelectedNodeThen(() => {
                                this.fetchTableDataForCurrentTab();
                            });
                        }
                        // 初回処理フラグはこのタイミングで除去して良い
                        sessionStorage.removeItem('isTransition');
                    })
                    .catch((e) => {
                        // エラー時も通常取得へフォールバック
                        this.forceIpRadioPreselect = false;
                        this.objectDataList = { users: [], maxUserTotal: 0, talkGroups: [], maxTalkGroupTotal: 0, ipRadios: [], maxIpRadioTotal: 0};
                        this.waitSelectedNodeThen(() => {
                            this.fetchTableDataForCurrentTab();
                        });
                        // 初回処理フラグはこのタイミングで除去して良い
                        sessionStorage.removeItem('isTransition');
                    })
                    .finally(() => {
                        // 初期処理完了。以降のツリークリックで通常取得を許可
                        console.log("transitionPending = false");
                        this.transitionPending = false;
                    });
            } else {
                // tenantName が取得できない場合も通常取得へ
                this.forceIpRadioPreselect = false;
                this.waitSelectedNodeThen(() => {
                    this.fetchTableDataForCurrentTab();
                });
                sessionStorage.removeItem('isTransition');
                this.transitionPending = false;
            }
        }
    },
    watch: {
        showImportCsvProcess(newVal) {
            if (newVal) {
                this.showCsvProcessing = true;
            } else {
                this.showCsvProcessing = false;
            }
        },
        showExportCsvProcess(newVal) {
            if (newVal) {
                this.showCsvProcessing = true;
            } else {
                this.showCsvProcessing = false;
            }
        },
        'appData.tenantList'(newVal) {
            if (newVal != null) {
                if (this.appData.basicContract != null) {
                    this.show = true;
                    this.$nextTick(() => {
                        this.checkExportRequest();
                    });
                }
                this.loadTableViewColumns();
            }
        },
        'appData.loginUserObjectId'(newVal) {
            if (newVal != null) {
                this.loadTableViewColumns();
            }
        },
        'appData.basicContract'(newVal) {
            if (newVal != null) {
                if (this.appData.tenantList != null) {
                    this.show = true;
                    this.$nextTick(() => {
                        this.checkExportRequest();
                    });
                }
            }
        },
        'appData.csvProcessing'(newVal) {
            if (this.appData.csvProcessing) {
                this.disableCreateCommand();
            } else {
                if (this.selectedNode != null) {
                    switch (this.selectedNode.node.data.type) {
                        case constants.OBJECT_NODE:
                            this.enableCreateCommand();
                            break;
                        case constants.OBJECT_USER:
                        case constants.OBJECT_TALKGROUP:
                            this.disableCreateCommand();
                            break;
                    }
                }
            }
        },
        'appData.enableBuddyComCall'(newVal) {
            if(newVal){
                this.checkBuddycomCallNumberContract();
            }
        },
        'appData.enableBuddyComCallTrial'(newVal) {
            if(newVal){
                this.checkBuddycomCallNumberContract();
            }
        },
        'appData.customFieldName'(newVal) {
            this.updateCustomFieldName(newVal);
        },
        '$route' (to, from) {
            if (to.name == "User") {
                this.resetUserViewState(this.isLastViewTable);
            }
            if (from.name == "User") {
                this.isLastViewTable = this.isTableViewEnable;
                clearInterval(this.timerObj);
                this.timerObj = null;
                this.showImportCsvProcess = false;
            }
        },
        'appData.enableLongTalkgroup'(newVal) {
            this.enableLongTalkgroup = newVal;
        },
    },
    props: ['appData']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item {
    width: 100%;
}

.inner-panel {
    position:relative;
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #ffffff;
}

.scrollable {
    overflow: auto;
    position: absolute;
    top: 0;
    right:0;
    bottom: 0;
    left: 0;
}

.scrollable::after {
    content: '';
    display: block;
    height: 14px;
}

.command-area {
    background-color: #ecf1fa;
    width: 100%;
    display: block;
    text-align: left;
    padding-left: 20px;
    height: 56px;
    vertical-align: bottom;
}

.command-area img {
  display: inline;
  vertical-align: middle;
  height: 25px;
  padding-left: 16px;
  padding-right: 4px;
}
.command-area-left {
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: middle;
    float: left;
}
.command-area-right {
    padding-right: 24px;
    padding-top: 15px;
    text-align : right;
    vertical-align: middle;
}
.normal-command {
    color: #5171cb;

}
.normal-command:hover {
    opacity: 0.7;
}
.csv-progress-title {
    padding: 10px 0 20px 0;
    text-align: center;
}
.csv-progress-title-summary {
    padding-top: 0;
}

.dropdownTalkgroup {
  position: relative;
  display: inline-block;
}
.dropdownTalkgroup-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin: 0;
  padding: 8px;
  background: #fff;
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 100;
  min-width: 140px;
  border-radius: 4px;
}
.dropdownTalkgroup-menu button {
  padding: 6px 12px;
  border: 1px solid #aaa;
  background: #f8f8f8;
  cursor: pointer;
  text-align: left;
  border-radius: 4px;
}
.dropdownTalkgroup-menu button:hover {
  background: #e0e0e0;
}

.layout-wrapper {
    width: 100%;
    overflow-x: auto;
}
.table-title {
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
    white-space: nowrap;
    height: 42px;
    display:flex;
    align-items: center;
}
.table-title-left {

}
.table-title-right {
    margin-left: auto;
    padding-right: 10px;
}
button.tree-command-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
    padding-top: 10px;
}
.tree-command-text {
    padding-left: 5px;
    display: inline-block;
    font-size: 12px;
    color: #5171cb;
    vertical-align: middle;
}
.tree-command-text:hover {
    opacity: 0.7;
}
</style>
